import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Short from '@/pages/short_play'
import FilmScript from '@/pages/film_script'
import ShortFilm from '@/pages/short_film'
import IndustryReg from '@/pages/guest/industry/register'
import IndustryPay from '@/pages/guest/industry/pay'
import MediaReg from '@/pages/guest/media/register'
import AiFilm from '@/pages/ai'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '電影申報',
      component: Index
    },
    {
      path: '/film',
      name: '電影申報',
      component: Index
    },
    {
      path: '/short_tv',
      name: '短劇申報',
      component: Short
    },
    {
      path: '/film/script',
      name: '劇本申報',
      component: FilmScript
    },
    {
      path: '/short_film',
      name: '短片申報',
      component: ShortFilm
    },
    {
      path: '/guest/industry/register',
      name: '產業嘉賓',
      component: IndustryReg
    },
    {
      path: '/guest/industry/pay/:id',
      name: '支付',
      component: IndustryPay
    },
    {
      path: '/guest/media/register',
      name: '媒體嘉賓',
      component: MediaReg
    },
    {
      path: '/ai_film',
      name: 'AI電影申報',
      component: AiFilm,
      meta: { title: '亞洲AIGC國際電影節影片申報 Asia AIGC International FilmFestival -- Film Submission' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js